var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-smoke rounded mb-3"},[_c('Details',{attrs:{"left":_vm.$t('reservationAndUsageHistory.changePetInfo'),"right":_vm.petInfoText,"aClass":'--medium-gray col-8',"format-text":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }